import { Component, OnInit } from '@angular/core';
import { VersionService } from 'src/api/generated';
import { version } from 'package.json';
import { AppInfoService } from 'src/app/shared/services/app-info.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {

  public apiVersion: string = '';
  public feVersion: string = version;

  constructor(private _versionService: VersionService, public appInfo: AppInfoService) {
  }

  ngOnInit(): void {
    this._versionService.getCurrentVersionVersion().subscribe(version => {
      this.apiVersion = version;
    });
  }
}
